import type { oz } from '@weft/utils';
import { NewFixedVariantChargeSchema } from './new-fixed-variant-charge-schema';

export const AnonymousFixedVariantChargeSchema = NewFixedVariantChargeSchema.omit({
  accountId: true,
  contractId: true,
});

export type AnonymousFixedVariantCharge = oz.infer<typeof AnonymousFixedVariantChargeSchema>;
